import { BrowserRouter, Route, Routes, useSearchParams } from "react-router-dom";
import { AnimatePresence } from 'framer-motion';
import { ScrollToTop } from "./components/ScrollToTop";
import { PlayerBar } from "./components/PlayerBar";
import { FullscreenPlayer } from "./components/FullscreenPlayer";
import { usePlayer } from "./contexts/PlayerContext";

import Index from "./pages/Index";
import { SharedTrackPage } from "./pages/SharedTrackPage";
import { WalletPage } from "./pages/WalletPage";
import { LibraryPage } from "./pages/LibraryPage";
import { ArtistProfile } from "./pages/ArtistProfile";
import { MyProfilePage } from "./pages/MyProfilePage";
import NotFound from "./pages/NotFound";

// Component to handle routing based on query params
function HomePage() {
  const [searchParams] = useSearchParams();
  const hasTrackParam = searchParams.has('track');
  
  // If there's a track param, show the shared track page
  if (hasTrackParam) {
    return <SharedTrackPage />;
  }
  
  // Otherwise show the normal index
  return <Index />;
}

function AppLayout() {
  const { currentTrack, showFullscreen, setShowFullscreen } = usePlayer();

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/profile" element={<MyProfilePage />} />
        {/* Artist profile by npub */}
        <Route path="/:npub" element={<ArtistProfile />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* Global Player Bar - always visible, persists across all pages */}
      <PlayerBar onExpand={() => setShowFullscreen(true)} />

      {/* Fullscreen Player */}
      <AnimatePresence>
        {showFullscreen && currentTrack && (
          <FullscreenPlayer onClose={() => setShowFullscreen(false)} />
        )}
      </AnimatePresence>
    </>
  );
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppLayout />
    </BrowserRouter>
  );
}
export default AppRouter;
